import React from 'react';
import Downshift from 'downshift';
import DoneIcon from '@material-ui/icons/Done';
import ScanQRIcon from '@material-ui/icons/CenterFocusWeak';
import { InputAdornment, MenuItem, Paper, TextField, makeStyles } from '@material-ui/core';
import ZxingReader from './zxingReader';
import CrimeObject from '../model/CrimeObject';
import SubjectConfig from '../helper/SubjectConfig';

type MenuItemProps = {
    obj: CrimeObject,
    itemProps: any,
    onSelect: (obj: CrimeObject) => void
}

function renderMenuItem(suggestionProps: MenuItemProps) {
    const { obj, itemProps, onSelect } = suggestionProps;
    return (
        <div key={obj.id} onClick={() => { onSelect(obj) }} >
            <MenuItem {...itemProps} component="div">
                {obj.title}
            </MenuItem>
        </div>
    );
}

const useStyles = makeStyles(theme => ({
    container: {
        flexGrow: 1,
        position: 'relative',
    },
    paper: {
        position: 'absolute',
        zIndex: 2,
        marginTop: theme.spacing(-1),
        left: 0,
        right: 0,
    },
    textField: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1),

    }
}));

type AutoCompleteObjectProps = {
    objectId: string,
    objectName: string,
    onChange: (id: string, title: string) => void,
}
const AutoCompleteObject: React.FC<AutoCompleteObjectProps> = (props) => {
    const classes = useStyles();
    const [openScanDialog, setOpenScanDialogState] = React.useState<boolean>(false);

    const listObjects: CrimeObject[] = SubjectConfig.getLocal().objects;
    /**
     * Возвращает массив отфильтрованных объектов
     * @param value значение для фильтрации
     */
    const filterListObjects = (value: string | null): CrimeObject[] => {
        let inputValue: (string | undefined) = value?.trim().toLowerCase();
        if (inputValue === undefined) return []
        if (listObjects.length === 0) return []
        let count = 0;
        // TODO ошибка выполнения при вводе спецсимволов, например '\'
        let regExpPattInputValue = new RegExp('(?=.*' + inputValue.replace(/ /g, ')(?=.*') + ')');
        // console.log(regExpPattInputValue);
        return inputValue.length >= 1 ? listObjects.filter((obj: CrimeObject) => {
            const keep = count < 10 && regExpPattInputValue.test(obj.title.toLowerCase());
            if (keep) count++
            return keep;
        }) : []
    }

    return (
        <div>
            <Downshift id="downshift-simple"  >
                {({ getInputProps, getItemProps, getMenuProps, inputValue, isOpen }) => {
                    const { onChange: superOnChange } = getInputProps();
                    return (
                        <div className={classes.container}>
                            <TextField className={classes.textField} label='Объект' placeholder='начните набор...' fullWidth
                                variant="outlined"
                                multiline
                                onChange={(event) => {
                                    props.onChange('', event.target.value);
                                    superOnChange(event);
                                }}
                                value={props.objectName}
                                InputProps={{
                                    endAdornment:
                                        props.objectId !== ''
                                            ?
                                            <InputAdornment position="end">
                                                <DoneIcon />
                                            </InputAdornment>
                                            :
                                            <InputAdornment position="end" onClick={() => setOpenScanDialogState(true)} >
                                                <ScanQRIcon color='primary' />
                                            </InputAdornment>
                                }}

                            />

                            <div {...getMenuProps()}>
                                {isOpen ? (
                                    <Paper className={classes.paper} square >
                                        {filterListObjects(inputValue).map((obj: CrimeObject) =>
                                            renderMenuItem({
                                                obj: obj,
                                                itemProps: getItemProps({ item: obj.title }),
                                                onSelect: () => { props.onChange(obj.id, obj.title) },
                                            }),
                                        )}
                                    </Paper>
                                ) : null}
                            </div>
                        </div>
                    );
                }}
            </Downshift>
            {openScanDialog ?
                <ZxingReader
                    onResult={(data: string) => {
                        setOpenScanDialogState(false);
                        let object = CrimeObject.fromQR(data);
                        if (object !== null) {
                            props.onChange(object.id, object.title)
                        } else {
                            alert('невалидный QR-код');
                            console.error('invalid object qr-code');
                        }
                    }}
                    onError={(msg: string) => {
                        alert(msg);
                        setOpenScanDialogState(false);
                        console.error(msg);
                    }}
                    onCancel={() => setOpenScanDialogState(false)}
                /> : null
            }

        </div>
    );
};
export default AutoCompleteObject